
export default function CoreFeatures() {
  const features = [
    {
      icon: 'ri-edit-box-line',
      title: '创建与修改',
      description: '注释、拆分、合并、扁平化、添加书签、链接和标签、下划线、高亮、添加内容、更改色彩空间和线性化。',
    },
    {
      icon: 'ri-refresh-line',
      title: '转换',
      description: '以编程方式转换文档：PDF转Word、Excel、PowerPoint、PDF/A、PDF/X、ZUGFeRD、EPS、PS和XPS。',
    },
    {
      icon: 'ri-file-list-3-line',
      title: '表单',
      description: '导入和导出表单数据，扁平化静态XFA和动态XFA表单，将XFA转换为AcroForm。',
    },
    {
      icon: 'ri-lock-line',
      title: '安全',
      description: '添加数字签名功能，设置、更改和删除密码，加密和解密，编辑，设置权限，水印和锁定文档。',
    },
    {
      icon: 'ri-text',
      title: '文本',
      description: 'OCR（光学字符识别）支持Tesseract支持的任何语言；搜索、按模式、区域和注释提取文本，插入页眉和页脚，添加字形、Unicode和垂直文本。',
    },
    {
      icon: 'ri-image-line',
      title: '图像',
      description: '提取、导入和导出、渲染、光栅化、创建缩略图、透明度和分色，查找图像分辨率，计算DPI和预览输出。',
    },
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            核心功能
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            全面的PDF处理能力，满足企业级应用需求
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-all duration-300 hover:scale-105"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
